'use strict';

var cubicBezier = require('./cubic-bezier.cjs');

const easeIn = /*@__PURE__*/ cubicBezier.cubicBezier(0.42, 0, 1, 1);
const easeOut = /*@__PURE__*/ cubicBezier.cubicBezier(0, 0, 0.58, 1);
const easeInOut = /*@__PURE__*/ cubicBezier.cubicBezier(0.42, 0, 0.58, 1);

exports.easeIn = easeIn;
exports.easeInOut = easeInOut;
exports.easeOut = easeOut;
//# sourceMappingURL=ease.cjs.map
